import { BookingListMultiSelectService } from './booking-management/booking-list/booking-list-multi-select.service';
import {BrowserModule, Title} from '@angular/platform-browser';
import {NgModule} from '@angular/core';
import {HttpModule} from '@angular/http';
import {AppComponent} from './app.component';
import {AuthModule} from './auth/auth.module';
import {BookingFormModule} from './booking-management/booking-form/booking-form.module';
import {BookingHeaderModule} from './booking-management/booking-header/booking-header.module';
import {DashboardComponent} from './dashboard/dashboard.component';
import {SharedModule} from './shared/shared.module';
import {UserManagementComponent} from './user-management/user-management.component';
import {UserService} from './api/user.service';
import {BookingService} from './api/booking.service';
import {Http, RequestOptions} from '@angular/http';
import {NotFoundComponent} from './not-found/not-found.component';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {CustomFormsModule} from 'ng2-validation';
import {routing} from './app.routing';
import {APP_BASE_HREF, DatePipe} from '@angular/common';
import {authService} from './shared/global';
import {AuthGuard} from './auth/auth.guard';
import {NotificationComponent} from './notification/notification.component';
import {BookingComponent} from './booking-management/booking.component';
import {BookingDetailComponent} from './booking-management/booking-detail/booking-detail.component';
import {SpinnerComponent} from './spinner/spinner.component';
import {SpinnerService} from './spinner/spinner.service';
import {HeaderComponent} from './ui/header/header.component';
import {BookingFilterComponent} from './booking-management/booking-filter/booking-filter.component';
import {BookingListComponent} from './booking-management/booking-list/booking-list.component';
import {UserListComponent} from './user-management/user-list/user-list.component';
import {UserFilterComponent} from './user-management/user-filter/user-filter.component';
import {UserHeaderComponent} from './user-management/user-header/user-header.component';
import {MaterialModule} from '@angular/material';
import {UserNameService} from './shared/user-name.service';
import {Md2Module} from 'md2';
import {SimpleNotificationsModule} from 'angular2-notifications';
import {NotificationServiceBus} from './notification/notification.service';
import {UserProfileComponent} from './user-management/user-profile/user-profile.component';
import {LinkHelper, LinkAuth} from './shared/router/linkhelper';
import {RouterModule} from '@angular/router';
import {AuthHttp} from 'angular2-jwt';
import {BookingJobsComponent} from './booking-management/booking-jobs/booking-jobs.component';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {RolePermission} from './shared/role-permission/role-permission';
import {CommonModule} from '@angular/common';
import {NoAuthGuard} from './auth/no-auth.guard';
import {PopupComponent} from './shared/popup/popup.component';
import {MobileFooterModule} from './ui/mobile-footer/mobile-footer.module';
import {SkillMatrixComponent} from './user-management/skill-matrix/skill-matrix.component';
import {AccountantComponent} from './ui/accountant/accountant.component';
import {UserPasswordComponent} from './user-management/user-password/user-password.component';
import {FileUploadModule} from 'ng2-file-upload';
import {HashLocationStrategy, Location, LocationStrategy} from '@angular/common';
import {BlockoutComponent} from './user-management/user-profile/blockout/blockout.component';
import {CalendarModule} from 'ap-angular2-fullcalendar';
import {InterpreterPopupComponent} from './shared/ui/interpreter-popup/interpreter-popup.component';
import {PreferedAllocationService} from './shared/prefered-allocation.service';
import {BookingHeaderService} from './booking-management/booking-header/booking-header.service';
import {GmapsApiService} from './api/gmaps-api.service';
import {NgxPaginationModule} from 'ngx-pagination';
import {AgmCoreModule} from '@agm/core';
import {AutoCompleteModule, CalendarModule as PrimeNgCalendarModule} from 'primeng/primeng';
import {LinkidPopupComponent} from './booking-management/linkid-popup/linkid-popup.component';
import {BookingInfoComponent} from './booking-management/booking-info/booking-info.component';
import {BookingPayrollComponent} from './booking-management/booking-payroll/booking-payroll.component';
import {PayrollTimeComponent} from './booking-management/payroll-time/payroll-time.component';
import { StaffCalendarComponent } from './user-management/staff-calendar/staff-calendar.component';
import {UserPayrollBillingComponent} from './user-management/user-payroll-billing/user-payroll-billing.component';
import { InboxComponent } from './messaging/inbox/inbox.component';
import { MessagingService } from './api/messaging.service';
import { MdCheckboxModule } from '@angular/material';
import { AngularMultiSelectModule } from 'angular2-multiselect-dropdown/angular2-multiselect-dropdown';

import { ReportsComponent } from './reports/reports.component';
import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import {VerifiedGuard} from './auth/verified.guard';
import { PayrollAdditionalCostsComponent } from './booking-management/payroll-additional-costs/payroll-additional-costs.component';
import { BookingRateCalulationComponent } from './booking-management/booking-rate-calculation /booking-rate-calulation.component';
import { CancelReasonPopupComponent } from './booking-management/cancel-reason-popup/cancel-reason-popup.component';
import { ScreenGuardModule } from './screen-guard/screen-guard.module';
import { PasswordValidatorModule } from './shared/validators/index';
import { UserPasswordFormModule } from './user-management/user-password/user-password-form/user-password-form.module';
import { AuthTokenGuard } from './auth/auth-token.guard';
import { ModalModule } from './shared/modal/modal.module';
import { SubOrganisationFilterService } from './shared/sub-organisation-filter/sub-organisation-filter.service';
import { PopupService } from './shared/popup/popup.service';
const PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
    suppressScrollX: true
};

@NgModule({
    declarations: [
        AppComponent,
        DashboardComponent,
        NotFoundComponent,
        NotificationComponent,
        SpinnerComponent,
        HeaderComponent,
        BookingComponent,
        BookingDetailComponent,
        BookingListComponent,
        BookingFilterComponent,
        UserManagementComponent,
        UserFilterComponent,
        UserListComponent,
        UserHeaderComponent,
        UserProfileComponent,
        BookingJobsComponent, PopupComponent,
        SkillMatrixComponent, AccountantComponent,
        UserPasswordComponent, BlockoutComponent,
        InterpreterPopupComponent, LinkidPopupComponent, CancelReasonPopupComponent,
        BookingInfoComponent, BookingPayrollComponent, PayrollTimeComponent, StaffCalendarComponent, UserPayrollBillingComponent, InboxComponent
        , BookingPayrollComponent, PayrollTimeComponent, StaffCalendarComponent, UserPayrollBillingComponent,
         ReportsComponent, PayrollAdditionalCostsComponent, BookingRateCalulationComponent
    ],
    entryComponents: [PopupComponent, InterpreterPopupComponent, LinkidPopupComponent],
    imports: [CustomFormsModule, FileUploadModule, MdCheckboxModule,
        BrowserModule, RouterModule, CommonModule, MobileFooterModule,
        FormsModule, BrowserAnimationsModule, NgxPaginationModule,
        HttpModule, SimpleNotificationsModule.forRoot(),
        ReactiveFormsModule, Md2Module.forRoot(),
        PerfectScrollbarModule.forRoot(PERFECT_SCROLLBAR_CONFIG),
        MaterialModule, CalendarModule, PrimeNgCalendarModule, AgmCoreModule.forRoot({
            apiKey: 'AIzaSyCFlZ1psfA1dNZ2yC4GGVj54X1I35xh8iM',
            libraries: ['places']
        }),
        AutoCompleteModule, AngularMultiSelectModule,
        SharedModule,
        PasswordValidatorModule,
        /* feature modules*/
        AuthModule,
        BookingHeaderModule,
        BookingFormModule,
        ScreenGuardModule,
        UserPasswordFormModule,
        ModalModule,
        routing // must be after feature modules
    ], providers: [DatePipe, LinkAuth, UserNameService, RolePermission, AuthGuard, VerifiedGuard, NoAuthGuard, Title, LinkHelper,
        NotificationServiceBus, SpinnerService, BookingService, UserService,
        PreferedAllocationService, BookingHeaderService, GmapsApiService, MessagingService, AuthTokenGuard, PopupService,
        {provide: APP_BASE_HREF, useValue: '/'},
        {
            provide: AuthHttp,
            useFactory: authService,
            deps: [Http, RequestOptions]
        }, Location, {provide: LocationStrategy, useClass: HashLocationStrategy}, BookingListMultiSelectService, SubOrganisationFilterService],
    bootstrap: [AppComponent],
})
export class AppModule {
    location: Location;

    constructor(location: Location) {
        this.location = location;
    }
}



// WEBPACK FOOTER //
// ./src/app/app.module.ts